import {ReportTableColumn, ReportTableConfigInterface, ReportTableData} from '../../../app/shared/components';

export const JurisdictionalRiskCountrySelector = 'jurisdictionalRiskCountry';
export const JurisdictionalRiskCountryTypeSelector = 'jurisdictionalRiskCountryType';
export const JurisdictionalRiskClassificationSelector = 'jurisdictionalRiskClassification';
export const JurisdictionalRiskScoreSelector = 'jurisdictionalRiskScore';

export const JurisdictionalRiskDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: JurisdictionalRiskCountryTypeSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: JurisdictionalRiskCountrySelector,
            value: null,
            hidden: false,
        }),
        new ReportTableData<string>({
            colId: JurisdictionalRiskClassificationSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: JurisdictionalRiskScoreSelector,
            value: null,
            hidden: false
        })
    ];
};

export const JurisdictionalRiskDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Type',
            selector: JurisdictionalRiskCountrySelector
        }),
        new ReportTableColumn({
            label: 'Country',
            selector: JurisdictionalRiskCountryTypeSelector
        }),
        new ReportTableColumn({
            label: 'Risk level',
            selector: JurisdictionalRiskClassificationSelector
        }),
        new ReportTableColumn({
            label: 'Risk score',
            selector: JurisdictionalRiskScoreSelector
        })
    ],
    hiddenColumnIds: [],
    actionMenu: false,
    disableColumnsOptions: true
};
